"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateIfFieldMatchesValue = exports.refusedBloodDonorRequired = exports.receivedBloodTransfusionRequired = exports.phoneNumberRequired = exports.personIdRequired = exports.personCategoryRequired = exports.minWeight = exports.maxBmi = exports.fieldValidation = exports.conditionRequired = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _types = require("../../../types");

var _validation = require("../../../types/validation");

var _index = require("../index");

var _bmiFailContent = _interopRequireDefault(require("../../../components/HeightWeight/bmiFailContent"));

var _weightFailContent = _interopRequireDefault(require("../../../components/HeightWeight/weightFailContent"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-cycle
var FieldRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _validation.FieldRuleDefinition;
});

var ComponentRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentRuleDefinition;
});

var Validator = _flowRuntime["default"].tdz(function () {
  return _types.Validator;
});

var calculateBMI = function calculateBMI(height, weight) {
  var bmi = weight / (height / 100 * (height / 100));
  return Number.isNaN(bmi) ? 'unknown' : bmi.toFixed(2);
};

var maxBmi = function maxBmi(num, componentKey) {
  return function (value, allValues) {
    var component = _lodash["default"].get(allValues, componentKey);

    return !component || !component.height || !component.weight || // $FlowFixMe - cannot compare string to number
    component && calculateBMI(component.height, component.weight) < num ? undefined : _bmiFailContent["default"];
  };
};

exports.maxBmi = maxBmi;

var minWeight = function minWeight(num, componentKey) {
  return function (value, allValues) {
    var component = _lodash["default"].get(allValues, componentKey);

    return !component || !component.weight || !component.height || component.weight >= num ? undefined : _weightFailContent["default"];
  };
};

exports.minWeight = minWeight;

var conditionRequired = function conditionRequired(componentKey) {
  return function (value, allValues) {
    var component = _lodash["default"].get(allValues, componentKey);

    return !component || component.yearDiagnosed && component.details && component.ongoing !== undefined ? undefined : 'All of the condition fields are required';
  };
};

exports.conditionRequired = conditionRequired;

var personCategoryRequired = function personCategoryRequired(componentKey) {
  return function (value, allValues) {
    var component = _lodash["default"].get(allValues, componentKey);

    return component && (component.donor || component.supporter) ? undefined : 'At least one is required';
  };
};

exports.personCategoryRequired = personCategoryRequired;

var personIdRequired = function personIdRequired(componentKey) {
  return function (value, allValues) {
    var component = _lodash["default"].get(allValues, componentKey);

    var donor = component && component.donor;
    var donorId = component && component.donorId;
    var supporter = component && component.supporter;
    var supporterId = component && component.supporterId;

    var errorMessage = function errorMessage() {
      var idType = '';

      if (donor && !donorId && supporter && !supporterId) {
        idType = 'Supporter and Donor';
      } else if (donor && !donorId) {
        idType = 'Donor';
      } else if (supporter && !supporterId) {
        idType = 'Supporter';
      }

      return "".concat(idType, " number required");
    };

    return donor && donorId && supporter && supporterId || donor && donorId && !supporter || supporter && supporterId && !donor || !donor && !supporter ? undefined : errorMessage();
  };
};

exports.personIdRequired = personIdRequired;

var phoneNumberRequired = function phoneNumberRequired(componentKey) {
  return function (value, allValues) {
    var component = _lodash["default"].get(allValues, componentKey);

    return component && (component.home || component.mobile || component.work) ? undefined : 'At least one phone number is required';
  };
};

exports.phoneNumberRequired = phoneNumberRequired;

var receivedBloodTransfusionRequired = function receivedBloodTransfusionRequired(componentKey) {
  return function (value, allValues) {
    var component = _lodash["default"].get(allValues, componentKey);

    return component && (!component.option || component.reason && component.year && component.country) ? undefined : 'All fields are required';
  };
};

exports.receivedBloodTransfusionRequired = receivedBloodTransfusionRequired;

var refusedBloodDonorRequired = function refusedBloodDonorRequired(componentKey) {
  return function (value, allValues) {
    var component = _lodash["default"].get(allValues, componentKey);

    return component && (!component.option || component.reason) ? undefined : 'All fields are required';
  };
};

exports.refusedBloodDonorRequired = refusedBloodDonorRequired;

var fieldValidation = function fieldValidation(componentKey, fieldKey, fieldValidationConfig) {
  return function (value, allValues, props, name) {
    var fieldValidator = (0, _index.getFieldValidator)(fieldValidationConfig);

    var componentValue = _lodash["default"].get(allValues, componentKey);

    var fieldValue = _lodash["default"].get(componentValue, fieldKey);

    return fieldValidator(fieldValue, allValues, props, name);
  };
};

exports.fieldValidation = fieldValidation;

var validateIfFieldMatchesValue = function validateIfFieldMatchesValue(componentKey, fieldKey, expectedValue, validationRule) {
  return function (value, allValues, props, name) {
    var componentValue = _lodash["default"].get(allValues, componentKey);

    var fieldValue = _lodash["default"].get(componentValue, fieldKey);

    if (fieldValue === expectedValue) {
      var validator = (0, _index.getComponentValidator)(validationRule, componentKey);
      return validator(value, allValues, props, name);
    }

    return undefined;
  };
};

exports.validateIfFieldMatchesValue = validateIfFieldMatchesValue;